import { useLanguageTranslator } from "hooks/use-language-translator";
import { ConfirmationPopUp } from "../modals";
import { data, getData } from "./constants";
import styles from "./styles.module.scss";
import { CloseCaseIconRed, DeleteIconRed, OpenCaseIcon } from "icons";
import { useState } from "react";
import { UseApiCallV2, UseLazyApiCallV2 } from "hooks";
import { useNavigate, useParams } from "react-router-dom";
import { message, Tooltip } from "antd";
import { useCurrentUserContext } from "providers";
import { ConditionalRenderer } from "components";
import { FileNumberSmile } from "../file-number-smile";
import { NameInitials } from "components/name-initials";
import { getInitialLetters } from "utils/constants";
import { UpdateCaseStatus } from "../update-case-status";

export const Settings = ({
  caseDetail,
  refetchDetail,
  case_id,
  utilityCount,
  caseTotalStatuses,
  caseStatus,
  caseStatusLocal,
  setCaseStatusLocal,
}) => {
  const { translator } = useLanguageTranslator();
  const { user } = useCurrentUserContext();
  const navigate = useNavigate();
  const [
    closeCase,
    { data: closeCaseData, isLoading: closeCaseLoading, error: closeCaseErr },
  ] = UseLazyApiCallV2({
    url: "/update_status",
    method: "POST",
  });

  const {
    data: caseSettingsData,
    isLoading: caseSettingsLoading,
    error: caseSettingsErr,
  } = UseApiCallV2({
    url: "/case_settings",
    method: "POST",
    paramsData: {
      case_id,
    },
  });

  const [openModalCloseCase, setOpenModalCloseCase] = useState(false);

  const icons = [
    {
      icon: DeleteIconRed,
      key: "deleteCase",
      handleClick: handleOpenDeleteCaseModal,
      height: 15,
      width: 15,
      label: "Delete Case",
    },
    // {
    //   icon:
    //     caseDetail?.caseStatus === "pending" ? CloseCaseIconRed : OpenCaseIcon,
    //   key: caseDetail?.caseStatus === "closed" ? "openCase" : "closeCase",
    //   handleClick: handleOpenCloseCaseModal,
    //   height: 15,
    //   width: 15,
    //   label: "Close Case",
    // },
  ];

  const [openModalDeleteCase, setOpenModalDeleteCase] = useState(false);
  const { caseId } = useParams();
  const [
    deleteCase,
    {
      data: deleteCaseData,
      isLoading: deleteCaseLoading,
      error: deleteCaseErr,
    },
  ] = UseLazyApiCallV2({
    url: "/delete_case",
    method: "POST",
  });
  function handleOpenCloseCaseModal() {
    setOpenModalCloseCase(true);
  }

  async function handleDeleteCase() {
    try {
      const res = await deleteCase({ params: { case_id: caseId } });
      if (res?.status === "SUCCESS") {
        message.success(res?.message);
        handleCloseDeleteCaseModal();
        navigate("/cases");
      } else {
        message.error(translator("somethingWentWrong"));
      }
    } catch (error) {
      console.log({ error });
    }
  }

  function handleOpenDeleteCaseModal() {
    setOpenModalDeleteCase(true);
  }

  function handleCloseDeleteCaseModal() {
    setOpenModalDeleteCase(false);
  }

  function handleCloseCloseCaseModal() {
    setOpenModalCloseCase(false);
  }
  async function handleCloseCase() {
    try {
      const res = await closeCase({
        params: {
          case_id: caseId,
          status: caseDetail?.caseStatus === "closed" ? "pending" : "closed",
          loggedUser: user?.email,
        },
      });
      if (res?.status === "SUCCESS") {
        message.success(res?.message);
        handleCloseCloseCaseModal();
        await refetchDetail();
      } else {
        message.error(translator("somethingWentWrong"));
      }
    } catch (error) {
      console.log({ error });
    }
  }

  const data = getData(caseSettingsData?.case, utilityCount);
  const row1 = data?.slice(0, 2);
  const row2 = data?.slice(2);
  const rows = [row1, row2];

  return (
    <>
      <div className={styles.titleAndActions}>
        <div>
          <FileNumberSmile
            caseTotalStatuses={caseTotalStatuses}
            caseStatus={caseStatus}
            caseStatusLocal={caseStatusLocal}
            setCaseStatusLocal={setCaseStatusLocal}
          />
          {/* <div className={styles.title}>Case Details</div>
          <div className={styles.info}>
            Following information contains all details and activities related to
            your case.
          </div> */}
        </div>

        <div className={styles.icons}>
          {icons.map((item) => (
            <div
              key={item.key}
              className={styles.iconContainer}
              onClick={item.handleClick}
              style={{
                display: "flex",
              }}
            >
              <div className={styles.icon}>
                <item.icon style={{ height: item.height, width: item.width }} />
              </div>
              {translator(`caseDetail.${item.key}`)}
            </div>
          ))}
          <UpdateCaseStatus
            caseStatusLocal={caseStatusLocal}
            setCaseStatusLocal={setCaseStatusLocal}
            caseStatus={caseStatus}
            caseTotalStatuses={caseTotalStatuses}
            className={styles.statusUpdate}
            refetchDetail={refetchDetail}
          />
        </div>
      </div>
      <div className={styles.rows}>
        {rows?.map((row, i) => (
          <div className={styles.cards} key={i}>
            {row.map((item) => (
              <SingleSection
                item={item}
                translator={translator}
                key={item.key}
              />
            ))}
          </div>
        ))}
      </div>
      <ConfirmationPopUp
        Icon={DeleteIconRed}
        title={translator("deleteCase")}
        description={translator("confirmationForDeleteCase")}
        open={openModalDeleteCase}
        onClose={handleCloseDeleteCaseModal}
        onConfirm={handleDeleteCase}
      />
      <ConfirmationPopUp
        Icon={
          caseDetail?.caseStatus === "pending" ? CloseCaseIconRed : OpenCaseIcon
        }
        title={
          caseDetail?.caseStatus === "pending"
            ? translator("closeCase")
            : translator("openCase")
        }
        description={
          caseDetail?.caseStatus === "pending"
            ? translator("confirmationForCloseCase")
            : translator("confirmationForOpenCase")
        }
        open={openModalCloseCase}
        onClose={handleCloseCloseCaseModal}
        onConfirm={handleCloseCase}
      />
    </>
  );
};

function SingleSection({ item, translator }) {
  return (
    <div
      className={styles.singleDetailCard}
      key={item.title}
      style={{
        // border: i === 1 && "none",
        width: `${item.width}`,
      }}
    >
      <div className={styles.icon}>
        <item.icon />
      </div>
      <div className={styles.details}>
        <div className={styles.title}>
          {translator(`caseDetail.caseSettings.${item.key}`)}
        </div>
        <div className={item.showInitials ? styles.initialsAndDetails : ""}>
          <div>
            <ConditionalRenderer condition={item.showInitials}>
              <NameInitials name={item.details[0].value} />
            </ConditionalRenderer>
          </div>
          <div className={styles.childs}>
            {item.details?.map((childItem) => (
              <div
                className={styles.singleChild}
                key={childItem.title}
                style={{
                  justifyContent: "space-between",
                }}
              >
                <div className={styles.lable}>
                  {translator(`caseDetail.caseSettings.${childItem.key}`)}:
                </div>
                <Tooltip
                  title={childItem?.title === "Email" ? childItem.value : ""}
                >
                  <div
                    className={`${styles.value} ${childItem?.title === "Email" ? styles.emailStyles : ""}`}
                  >
                    {childItem.value}
                  </div>
                </Tooltip>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
